import { render, staticRenderFns } from "./CoverIndicatorCard.vue?vue&type=template&id=2a5ef3fb&scoped=true&"
import script from "./CoverIndicatorCard.vue?vue&type=script&lang=js&"
export * from "./CoverIndicatorCard.vue?vue&type=script&lang=js&"
import style0 from "./CoverIndicatorCard.vue?vue&type=style&index=0&id=2a5ef3fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5ef3fb",
  null
  
)

export default component.exports